import {HttpClient} from '@angular/common/http'
import {Component, inject, OnInit, signal} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog'

@Component({
  selector: 'aku-licenses-dialog',
  templateUrl: './licenses-dialog.component.html',
  styleUrls: ['./licenses-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class LicensesDialogComponent implements OnInit {
  /* v8 ignore next @preserve */
  public licenseText = signal('')
  /* v8 ignore next @preserve */
  public loadError = signal(false)

  private readonly http = inject(HttpClient)

  ngOnInit(): void {
    this.loadLicenseText()
  }

  public loadLicenseText(): void {
    this.http.get('/3rdpartylicenses.txt', {responseType: 'text'})
      .subscribe({
        next: (response) => this.licenseText.set(response),
        error: () => this.loadError.set(true)
      })
  }
}